import TextValidator from './TextValidator';

export default TextValidator;
